import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_hdr_RowClass} from '../../../dbschema/bl_fi_mst_coupon_hdr';
import {bl_fi_mst_coupon_ext_RowClass} from '../../../dbschema/bl_fi_mst_coupon_ext';
import {bl_fi_mst_coupon_line_RowClass} from '../../../dbschema/bl_fi_mst_coupon_line';

export class VoucherContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_hdr: bl_fi_mst_coupon_hdr_RowClass = new bl_fi_mst_coupon_hdr_RowClass();
  bl_fi_mst_coupon_exts: bl_fi_mst_coupon_ext_RowClass[] = [];
  bl_fi_mst_coupon_lines: bl_fi_mst_coupon_line_RowClass[] = [];
}

export class VoucherQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;

  keyword: string;
  coupon_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
}


